import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { useContact, useUpdateContact } from "../hooks";
import { ContactForm } from "../components";

type IUpdateContact = {
  id: string;
};

export const UpdateContact: React.FC = () => {
  const { id } = useParams<IUpdateContact>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useContact(+id!);
  const { form, submit, loading } = useUpdateContact({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("Le contact a été modifié avec succès");
    },
  });

  useEffect(() => {
    if (data?.contact?.ok && data?.contact?.result) {
      const { result } = data.contact;
      form.setValue("firstname", result.firstname);
      form.setValue("lastname", result.lastname);
      form.setValue("jobTitleId", result.jobTitleId);
      form.setValue("isPrimary", result.isPrimary);
      form.setValue("active", result.active);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  return (
    <>
      <Header
        title="Contact"
        subtitle={`${data?.contact?.result?.firstname ?? ""} ${
          data?.contact?.result?.lastname ?? ""
        }`}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/contact/${id}`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier un contact" />
          <ContactForm loading={loading} form={form} submit={submit} />
        </div>
      </div>
    </>
  );
};
